import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import c from 'classnames';
import { ImmutableEntity, TaxonomyEntity } from '@uncinc/react-drupal-core/types';
import { useWindowDimensions, FormikWrapper } from '@uncinc/uncinc-react-kitchen-sink';
import Select from '@uncinc/uncinc-react-kitchen-sink/dist/components/Form/Select';

import { SCREEN_TABLET } from '../../../config/constants';

interface ViewTypesProps {
  entities: ImmutableEntity<TaxonomyEntity>[]
  filterArray: number[]
  setFilterArray: React.Dispatch<React.SetStateAction<number[]>>
  placeholder: string
}

interface ViewTypesCheckboxProps {
  checked: boolean
  label: string
  value: number
  setFilterArray: React.Dispatch<React.SetStateAction<number[]>>
}

const ViewTypesCheckbox: React.FC<ViewTypesCheckboxProps> = ({
  checked,
  value,
  label,
  setFilterArray,
}) => {
  const [hover, setHover] = useState(false);

  return (
    <button
      type="button"
      className={checked ? 'checked' : ''}
      onClick={() => (checked ?
        setFilterArray((state) => state.filter((x) => x !== value)) :
        setFilterArray((state) => [...state, value])
      )}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <i
        className={c('icon', {
          'icon-square': !checked,
          'icon-check-square': checked && !hover,
          'icon-cross-square': checked && hover,
        })}
      />
      <span>{label}</span>
    </button>
  );
};

const ViewTypes: React.FC<ViewTypesProps> = ({
  entities,
  filterArray,
  setFilterArray,
  placeholder,
}) => {
  const { width } = useWindowDimensions();
  const { t } = useTranslation();

  if (width < SCREEN_TABLET) {
    let types = [{ value: 0, label: t('general.all') }];
    entities.forEach((entity) => {
      const label = entity.getIn(['name', 0, 'value']);
      const value = entity.getIn(['tid', 0, 'value']);
      types = [...types, { value, label }];
    });

    return (
      <FormikWrapper>
        <Select
          placeholder={placeholder || t('locations.filter_placeholder')}
          fieldName="types"
          options={types}
          onChange={(value: number) => (value === 0 ? setFilterArray([]) : setFilterArray([value]))}
        />
      </FormikWrapper>
    );
  }

  return (
    <div className="Filters">
      {entities.map((entity) => {
        const label = entity.getIn(['name', 0, 'value']);
        const tid = entity.getIn(['tid', 0, 'value']);

        return (
          <ViewTypesCheckbox
            key={tid}
            label={label}
            value={tid}
            checked={filterArray.includes(tid)}
            setFilterArray={setFilterArray}
          />
        );
      })}
    </div>
  );
};

export default ViewTypes;
